module.exports = {"Study1":{"daobanList":[{"title":"1:申请人是否为全日高等院校录取学生？","index":0,"state":-1,"values":[{"name":"是","cailiaoList":[]},{"name":"否","cailiaoList":[{"name":"无"}]}]},{"title":"2、申请人是否为本区户籍残疾人并持有中华人民共和国二代或三代残疾人证？","index":1,"state":-1,"values":[{"name":"是","cailiaoList":[{"name":"1、银行账户","state":"必要"}]},{"name":"否","cailiaoList":[{"name":"无"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sds-1.json
// module id = 1295
// module chunks = 0